import React from "react";
import "../CSS/coustomers.css"; // Ensure correct CSS
import Infosys from "../Assets/logos/Infosys.jpg"
import Inventa from "../Assets/logos/Inventa.jpg"
import ncs from "../Assets/logos/NCS.jpg"
import Singtel from "../Assets/logos/SingTel.jpg"
import Covalense from "../Assets/logos/Covalense.jpg"
import Forgehead from "../Assets/logos/Forgehead.jpg"
import Irth from "../Assets/logos/IrthLogo.svg"
import optus from "../Assets/logos/Optus.jpg"
import GuavaTrees from "../Assets/logos/GuavaTrees.jpg"
import Knowledge from "../Assets/logos/Knowledge.jpg"
import Boltlogo from "../Assets/logos/Boltlogo.jpg"
import Jass from "../Assets/logos/Jass.jpg"
import Softenger from "../Assets/logos/Softenger.jpg"

const tagLists = [
  {
    duration: "15951ms",
    direction: "normal",
    tags: [
      { name: "Infosys", image: Infosys },
      { name: "Inventa", image: Inventa },
      { name: "ncs", image: ncs },
      { name: "Singtel", image: Singtel },
      { name: "GuavaTrees", image: GuavaTrees },
      { name: "Jass", image: Jass },

    ],
  },
  {
    duration: "19260ms",
    direction: "reverse",
    tags: [
      { name: "Softenger", image: Softenger },
      { name: "Covalense", image: Covalense },
      { name: "Infosys", image: Infosys },
      { name: "Forgehead", image: Forgehead },
      { name: "ncs", image: ncs },
      { name: "Knowledge", image: Knowledge },
    ],
  },
  {
    duration: "10449ms",
    direction: "normal",
    tags: [
      { name: "Covalense", image: Covalense },
      { name: "Forgehead", image: Forgehead },
      { name: "Irth", image: Irth },
      { name: "Optus", image: optus },
      { name: "Boltlogo", image: Boltlogo },
      { name: "Softenger", image: Softenger },


    ],
  },
];

const InfiniteScroll = () => {
  return (
    <div className="app">
      <div className="tag-list">
        {tagLists.map((list, index) => (
          <div
            key={index}
            className="loop-slider"
            style={{ "--duration": list.duration, "--direction": list.direction }}
          >
            <div className="inner">
              {list.tags.concat(list.tags).map((tag, i) => (
                <div className="tag" key={i}>
                  <img src={tag.image} alt={tag.name} />
                </div>
              ))}
            </div>
          </div>
        ))}
        <div className="fade"></div>
      </div>
    </div>
  );
};

export default InfiniteScroll;
